import moment from 'moment';

export const formatCheckDate = (date) => {
  const d = moment(date, 'YYYY-MM-DD HH:mm:ss');
  if (date && d.isValid()) {
    return d.format('DD/MM/YYYY')
  } else {
    return '-'
  }
}

export const formatDateShort = (date) => {
  if (date) {
    return moment(date, 'YYYY-MM-DD').format('DD/MM')
  }
}

export const formatDate = (date) => {
  if (date) {
    return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY')
  }
}

export const getDittaLabel = (value, currentCustomer = null) => {
  let bothBespoke = false
  if (currentCustomer?.navigableDitte) {
    const ditte = currentCustomer.navigableDitte.map(d => d.ditta)
    bothBespoke = ditte?.includes('002') && ditte?.includes('HGK')
  }

  if (value) {
    switch (value) {
      case "002":
        return bothBespoke ? "Bespoke IT" : "Bespoke";
      case "PRD":
        return "Production";
      case "HGK":
        return "Bespoke HK";
      case "STK":
        return "Promotions";
      default:
        return "";
    }
  } else return "";
}